import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type FolderOffProps = IconComponentBaseProps;

export const FolderOff = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.red[6],
}: FolderOffProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_7511_36760"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7511_36760)">
        <path
          d="M21.5 8.30758V16.8711C21.5 17.1211 21.4215 17.3086 21.2645 17.4336C21.1073 17.5586 20.9358 17.6211 20.75 17.6211C20.5641 17.6211 20.3926 17.556 20.2355 17.4258C20.0785 17.2957 20 17.1056 20 16.8556V8.30758C20 8.21774 19.9711 8.14399 19.9135 8.08633C19.8558 8.02866 19.782 7.99983 19.6922 7.99983H11.598C11.357 7.99983 11.1253 7.95299 10.903 7.85933C10.6805 7.76583 10.4871 7.63699 10.323 7.47283L8.64221 5.79208C8.46655 5.61641 8.38805 5.42891 8.40671 5.22958C8.42538 5.03024 8.50388 4.86133 8.64221 4.72283C8.78071 4.58449 8.94963 4.50599 9.14896 4.48733C9.3483 4.46883 9.5358 4.54733 9.71146 4.72283L11.4885 6.49983H19.6922C20.1974 6.49983 20.625 6.67483 20.975 7.02483C21.325 7.37483 21.5 7.80241 21.5 8.30758ZM4.30771 19.4998C3.80255 19.4998 3.37496 19.3248 3.02496 18.9748C2.67496 18.6248 2.49996 18.1972 2.49996 17.6921V6.30758C2.49996 5.80241 2.67496 5.37483 3.02496 5.02483C3.37496 4.67483 3.80255 4.49983 4.30771 4.49983H4.49996L5.99996 5.99983H4.30771C4.21788 5.99983 4.14413 6.02866 4.08646 6.08633C4.0288 6.144 3.99996 6.21774 3.99996 6.30758V17.6921C3.99996 17.7819 4.0288 17.8557 4.08646 17.9133C4.14413 17.971 4.21788 17.9998 4.30771 17.9998H15.877L2.14996 4.25758C2.01146 4.11908 1.93805 3.94758 1.92971 3.74308C1.92138 3.53858 1.9948 3.35883 2.14996 3.20383C2.2948 3.05883 2.47046 2.98633 2.67696 2.98633C2.8833 2.98633 3.05896 3.05883 3.20396 3.20383L21.1807 21.1806C21.3294 21.3292 21.4028 21.5032 21.401 21.7026C21.399 21.9021 21.3205 22.0793 21.1655 22.2343C21.0103 22.3793 20.8346 22.4543 20.6385 22.4593C20.4423 22.4645 20.2666 22.3895 20.1115 22.2343L17.377 19.4998H4.30771Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
